import Processor from './Processor/Processor'
import EnhanceStrategy from './Processor/Strategies/EnhanceStrategy'
import GenerateStrategy from './Processor/Strategies/GenerateStrategy'
import InpaintStrategy from './Processor/Strategies/InpaintStrategy'
import MixerStrategy from './Processor/Strategies/MixerStrategy'
import VariationsStrategy from './Processor/Strategies/VariationsStrategy'
import VideoBetaStrategy from './Processor/Strategies/VideoBetaStrategy'
import VideoStrategy from './Processor/Strategies/VideoStrategy'

export {
  EnhanceStrategy,
  GenerateStrategy,
  VariationsStrategy,
  VideoStrategy,
  MixerStrategy,
  InpaintStrategy,
  VideoBetaStrategy,
}

export default Processor
